/** profile — EN source (39 keys). */
export const profile = {
  profile_info_interests_label: "Interests",
  profile_info_about_label: "About",
  profile_info_photos_label: "Photos",
  profile_info_distance_mi: "{miles} mi",
  profile_info_distance_mi_nearby: "nearby",
  profile_info_full_name_age: "{name}, {age}",
  profile_edit_gender_label: "Gender",
  profile_edit_about_label: "About",
  profile_edit_first_name_label: "First name",
  profile_edit_last_name_label: "Last name",
  profile_edit_first_name_placeholder: "Enter your first name",
  profile_edit_last_name_placeholder: "Enter your last name",
  profile_edit_about_placeholder: "live, laugh, love amirite?",
  profile_edit_gender_text_none: "Prefer not to say",
  profile_edit_gender_text_male: "Man",
  profile_edit_gender_text_female: "Woman",
  profile_edit_birthdate_label: "Birthdate",
  profile_edit_birthdate_placeholder_day: "Day",
  profile_edit_birthdate_placeholder_month: "Month",
  profile_edit_birthdate_placeholder_year: "Year",
  profile_filter_gender_label: "I am interested in meeting",
  profile_filter_age_label: "Age",
  profile_filter_age_min_label: "From",
  profile_filter_age_max_label: "To",
  profile_filter_distance_label: "Distance",
  profile_filter_distance_label_value: "{radius} mi",
  profile_filter_gender_value_text_none: "Everyone",
  profile_filter_gender_value_text_male: "Man",
  profile_filter_gender_value_text_female: "Woman",
  profile_menu_edit_title: "Edit Profile",
  profile_menu_edit_subtitle: "Update your basic info and bio",
  profile_menu_filters_title: "Filters",
  profile_menu_filters_subtitle: "Adjust who you'd like to meet",
  profile_menu_photos_title: "Photos",
  profile_menu_photos_subtitle: "Manage or reorder your gallery",
  profile_menu_interests_title: "Interests",
  profile_menu_interests_subtitle: "Show what you care about",
  profile_menu_settings_title: "Settings",
  profile_menu_settings_subtitle: "Manage account & preferences",
};
